/**
 * Fecha "hoy" en formato YYYY-MM-DD usando la zona horaria del usuario.
 * Se envía al backend como param `hoy` para que las queries de ventana
 * móvil (`vigentes=true` en minutas y pedidos) usen la fecha del
 * cliente y no la del servidor MySQL (en UTC).
 */
export const getHoyLocal = (): string => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
